import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { getStoreLocalData, getUserData } from "../../../utils/localStorage";
import {
  getBrandStore,
  getBrandStoreById,
  getBrandUsers,
  postBrandStore,
  putBrandStore,
} from "../../../services/StoreUsers/PostStoreUsers";
import { formatDate } from "../../../constants/DateUtil/DateUtil";
import { ProgressSpinner } from "primereact/progressspinner";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import SuccessModal from "../../SuccessModal";
import {
  createWarehouse,
  getBrandWarehouseById,
  putWarehouse,
} from "../../../services/warehouse/Warehouse";
import AdminMenu from "../../AdminMenu";

const WarehouseManagementCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {}; // Fallback to prevent undefined errors

  const [storeInfoData, setStoreInfoData] = useState([]);

  const [visible, setVisible] = useState(false);

  const { storeLocalData } = getStoreLocalData();
    const countryCode = storeLocalData?.countryCode;

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;
  let enabledGarmentProcessStageBrand =
    brandProfileData.enabledGarmentProcessStage;
  const [warehouseInfoData, setWarehouseInfoData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isUpdating, setIsUpdating] = useState(id);
  const [modalMenuVisible, setModalMenuVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [isButtonPressed, setIsButtonPressed] = useState(false);

  const [statusValue, setStatusValue] = useState("");

  const [selectedItem, setSelectedItem] = useState(null);

  const handleItemPress = () => {
    setSelectedItem((prevSelectedItem) => !prevSelectedItem);
  };
  const fetchWarehouseUser = (id) => {
    getBrandWarehouseById(id)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setWarehouseInfoData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    if (isUpdating !== null) {
      fetchWarehouseUser(isUpdating);
    }
  }, [isUpdating]);

  const handleStatusChange = (selectedItem) => {
    setStatusValue(selectedItem.value);
  };

  const StatusList = [
    {
      name: "Active",
      value: true,
    },
    {
      name: "InActive",
      value: false,
    },
  ];

  const [input, setInput] = useState({
    address: {
      addressLine1: "",
      addressLine2: "",
      landmark: "",
      pin: "",
      city: "",
      state: "",
    },
    name: "",
    email: "",
    mobileNo: "",
    processTime: "",
    enabledGarmentProcessStage: false,
    enabledAutoUnProcess: false,
  });

  useEffect(() => {

    let savedMobileNo = warehouseInfoData?.mobileNo;

    if (countryCode && warehouseInfoData?.mobileNo?.startsWith(countryCode)) {
      savedMobileNo = warehouseInfoData?.mobileNo?.replace(countryCode, "").trim();
    }

    setInput((prevState) => ({
      ...prevState,
      address: {
        addressLine1: warehouseInfoData?.address?.addressLine1 || "",
        addressLine2: warehouseInfoData?.address?.addressLine2 || "",
        landmark: warehouseInfoData?.address?.landmark || "",
        pin: warehouseInfoData?.address?.pin || "",
        city: warehouseInfoData?.address?.city || "",
        state: warehouseInfoData?.address?.state || "",
      },
      name: warehouseInfoData?.name || "",
      email: warehouseInfoData?.email || "",
      mobileNo: savedMobileNo || "",
      processTime: warehouseInfoData?.processTime?.toString() || "",
      enabledGarmentProcessStage:
        warehouseInfoData?.enabledGarmentProcessStage || false,
      enabledAutoUnProcess: warehouseInfoData?.enabledAutoUnProcess || false,
    }));
    // setStatusValue(warehouseInfoData?.status === true ? 'Active' : 'InActive');
    setStatusValue(warehouseInfoData?.status);
  }, [warehouseInfoData]);

  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileNoError, setMobileNoError] = useState("");

  const handleConfirmAndContinue = () => {
    setModalMenuVisible(true);
  };

  const [focusedField, setFocusedField] = useState("");

  const handleFocus = (field) => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField("");
  };

  const handleMobileNumberChange = (number) => {
    // Perform input validation to allow only Indian mobile numbers
    // if (/^[56789]\d{0,9}$/.test(number) || number === "") {
    //   if (number.length === 10) {
    //     setMobileNoError(""); // Clear error if the input is valid
    //   } else {
    //     setMobileNoError("Please enter a 10-digit mobile number");
    //   }
    //   setInput({
    //     ...input,
    //     mobileNo: number,
    //   });
    // } else {
    //   setMobileNoError("Please enter a valid mobile number");
    // }

    let isValidPartial = false;
    let isValidFull = false;
    let requiredLength = 10;

    // Validation based on country code
    if (countryCode === "+91") {
      // India: starts with 5-9 and max 10 digits
      isValidPartial = /^[5-9]\d{0,9}$/.test(number) || number === "";
      isValidFull = /^[5-9]\d{9}$/.test(number);
      requiredLength = 10;

    } else if (countryCode === "+971") {
      // UAE: starts with 5 and max 9 digits
      isValidPartial = /^5\d{0,8}$/.test(number) || number === "";
      isValidFull = /^5\d{8}$/.test(number);
      requiredLength = 9;
    }

    if (isValidPartial) {
      if (number.length === requiredLength) {
        setMobileNoError("");
      } else {
        setMobileNoError(`Please enter a ${requiredLength}-digit mobile number`);
      }

      setInput({
        ...input,
        mobileNo: number,
      });
    } else {
      setMobileNoError("Please enter a valid mobile number");
    }
  };

  const isValidEmail = (email) => {
    // Regular expression for basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = () => {
    // Reset all previous errors

    setNameError("");
    setEmailError("");
    setMobileNoError("");

    let isValid = true;
    if (!input.name) {
      setNameError(" Name is Required");
      isValid = false;
    }
    if (!input.email) {
      setEmailError("Email is Required");
      isValid = false;
    }
    if (!input.mobileNo) {
      setMobileNoError("Mobile Number is Required");
      isValid = false;
    }

    if (isValid) {
      // Logic for creating a new pickup request
      if (!isButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsButtonPressed(true);

        const data = {
          ...input,
          mobileNo: countryCode + input.mobileNo,
          brandId: brandId,
        };

        const UpdateData = {
          ...input,
          mobileNo: countryCode + input.mobileNo,
          brandId: brandId,
          id: warehouseInfoData?.id,
          status: statusValue,
        };

        // Call the service function for creating pickup request

        if (!isUpdating) {
          createWarehouse(brandId, data)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                    setTimeout(() => {
                      navigate("/WarehouseManagementList");
                    }, 1500);
                    setIsButtonPressed(false);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                    setIsButtonPressed(false);
                  }
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          putWarehouse(brandId, UpdateData)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                    setTimeout(() => {
                      navigate("/WarehouseManagementList");
                    }, 1500);
                    setIsButtonPressed(false);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                    setIsButtonPressed(false);
                  }
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      } else {
        setIsButtonPressed(false);
      }
    }
  };

  return (
    <div className="flex-1" style={{ backgroundColor: "#FAF9F6" }}>
      <div
        className="h-3rem surface-0 sticky z-2 mb-3 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/WarehouseManagementList")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Warehouse {isUpdating ? "Edit" : "Create"}
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="name"
              value={input.name}
              onChange={(e) => {
                setInput({
                  ...input,
                  name: e.target.value,
                });
                setNameError("");
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {nameError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {nameError}
              </p>
            )}

            <label htmlFor="name" className="text-lg" style={{ color: "blue" }}>
              Name <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="email"
              value={input.email}
              onChange={(e) => {
                setInput({
                  ...input,
                  email: e.target.value,
                });
                if (!isValidEmail(e.target.value)) {
                  setEmailError("Please enter a valid email address");
                } else {
                  setEmailError("");
                }
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {emailError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {emailError}
              </p>
            )}

            <label
              htmlFor="email"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Email Id <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="mobileNo"
              value={input.mobileNo}
              onChange={(e) => {
                handleMobileNumberChange(e.target.value);
              }}
              keyboardType="numeric"
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
              maxLength={10}
            />
            {mobileNoError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {mobileNoError}
              </p>
            )}

            <label
              htmlFor="mobileNo"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Mobile Number <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="processTime"
              value={input.processTime}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setInput({
                    ...input,
                    processTime: value,
                  });
                }
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
              maxLength={2} // Restrict input to 10 characters
            />
            <label
              htmlFor="processTime"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Process Time
            </label>
          </FloatLabel>
        </div>
      </div>

      {/* address */}

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="addressLine1"
              value={input.address.addressLine1}
              onChange={(e) =>
                setInput({
                  ...input,
                  address: {
                    ...input.address,
                    addressLine1: e.target.value,
                  },
                })
              }
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />

            <label
              htmlFor="addressLine1"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Address Line1
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="addressLine2"
              value={input.address.addressLine2}
              onChange={(e) =>
                setInput({
                  ...input,
                  address: {
                    ...input.address,
                    addressLine2: e.target.value,
                  },
                })
              }
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />

            <label
              htmlFor="addressLine2"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Address Line2
            </label>
          </FloatLabel>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="city"
              value={input.address.city}
              onChange={(e) =>
                setInput({
                  ...input,
                  address: {
                    ...input.address,
                    city: e.target.value,
                  },
                })
              }
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />

            <label htmlFor="city" className="text-lg" style={{ color: "blue" }}>
              City
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="state"
              value={input.address.state}
              onChange={(e) =>
                setInput({
                  ...input,
                  address: {
                    ...input.address,
                    state: e.target.value,
                  },
                })
              }
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />

            <label
              htmlFor="state"
              className="text-lg"
              style={{ color: "blue" }}
            >
              State
            </label>
          </FloatLabel>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="landMark"
              value={input.address.landmark}
              onChange={(e) =>
                setInput({
                  ...input,
                  address: {
                    ...input.address,
                    landmark: e.target.value,
                  },
                })
              }
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />

            <label
              htmlFor="landMark"
              className="text-lg"
              style={{ color: "blue" }}
            >
              LandMark
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="pin"
              value={input.address.pin}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setInput({
                    ...input,
                    address: {
                      ...input.address,
                      pin: value,
                    },
                  });
                }
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
              keyboardType="numeric"
              maxLength={6}
            />

            <label htmlFor="pin" className="text-lg" style={{ color: "blue" }}>
              Pin Code
            </label>
          </FloatLabel>
        </div>
      </div>

      {enabledGarmentProcessStageBrand && (
        <div
          className="shadow-2 m-3 border-2 border-round-lg cursor-pointer"
          style={{ borderColor: "#fff", backgroundColor: "#fff" }}
        >
          <div
            className="px-3 py-1  flex flex-row justify-content-between align-items-center cursor-pointer"
            style={{
              backgroundColor: "#fff",
            }}
            onClick={() => handleItemPress()}
          >
            <div className="flex justify-content-center align-items-center">
              <img
                className="flex justify-content-center align-items-center mr-3"
                src={
                  "Laundy_App_Icons_Gifs/Other_Icons/Additional_Information.png"
                }
              />
              <p className="text-3xl font-bold capitalize">
                Additional Information
              </p>
            </div>

            <div>
              <i
                className={
                  !selectedItem ? "pi pi-angle-down" : "pi pi-angle-up"
                }
                style={{
                  fontSize: "25px",
                  cursor: "pointer",
                  color: "#000",
                }}
              ></i>
            </div>
          </div>
        </div>
      )}
      {selectedItem && (
        <div>
          <div className="flex flex-1">
            <div
              className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
              style={{ borderColor: "#fff", backgroundColor: "#fff" }}
            >
              <div className="flex justify-content-between align-items-center">
                <p className="text-lg font-medium">
                  Enabled Garment Process Stage
                </p>
                <div>
                  <Checkbox
                    checked={input.enabledGarmentProcessStage}
                    color={
                      input.enabledGarmentProcessStage ? "#00A3FF" : "#C1C9D3"
                    }
                    onClick={() =>
                      setInput({
                        ...input,
                        enabledGarmentProcessStage:
                          !input.enabledGarmentProcessStage,
                      })
                    }
                    size={20}
                  />
                </div>
              </div>
            </div>

            <div
              className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
              style={{ borderColor: "#fff", backgroundColor: "#fff" }}
            >
              <div className="flex justify-content-between align-items-center">
                <p className="text-lg font-medium">Enabled Auto UnProcess</p>
                <div>
                  <Checkbox
                    checked={input.enabledAutoUnProcess}
                    color={input.enabledAutoUnProcess ? "#00A3FF" : "#C1C9D3"}
                    onClick={() =>
                      setInput({
                        ...input,
                        enabledAutoUnProcess: !input.enabledAutoUnProcess,
                      })
                    }
                    size={20}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />

      <div className="flex ">
        <Button
          className="mt-1 mb-3 mx-4 border-round-xl w-full"
          onClick={handleSubmit}
          disabled={isButtonPressed}
        >
          <p className=" w-full text-2xl font-semibold flex justify-content-center">
            Submit
          </p>
        </Button>
      </div>
 
        <AdminMenu setVisible={setVisible} visible={visible} />
      
    </div>
  );
};

export default WarehouseManagementCreate;
